import IndeterminateCheckbox from '@/components/Table/components/IndeterminateCheckbox'
import EditableTable from '@/components/Table/EditableTable'
import useVendor from '@/features/vendors/useVendor'
import useUser from '@/features/users/useUser'
import { Box, Select } from '@chakra-ui/react'
import { createColumnHelper } from '@tanstack/react-table'
import React, { useMemo } from 'react'

const RFQModalVendorTable = ({ vendorDetails, selectedVendors, setSelectedVendors }) => {
  const columnHelper = createColumnHelper()

  const { useFetchAllVendors } = useVendor()
  const { useFetchAllUsers } = useUser()

  const { data: fetchVendorResponse } = useFetchAllVendors({
    page: 1,
    pageSize: 0,
    filter: {
      status: 'active',
    },
  })
  const { data: fetchVendorUserResponse } = useFetchAllUsers({
    page: 1,
    pageSize: 0,
    sortBy: 'fullName',
    orderBy: 1,
    filters: { role: 'vendor' },
  })
  const allVendorUsers = Array.isArray(fetchVendorUserResponse?.data) ? fetchVendorUserResponse?.data : []

  const formattedVendorDetails = vendorDetails.map((detail) => {
    const vendor = fetchVendorResponse?.data.find((vendor) => vendor._id === detail.vendor)
    const selectedVendorUsers = allVendorUsers.filter(
      (user) => Array.isArray(detail.contactPersons) && detail.contactPersons.includes(user._id)
    )
    return {
      vendorId: detail.vendor,
      vendorName: vendor?.name,
      contactPersonNames: selectedVendorUsers.map((user) => user.fullName).join(', '),
      contactPersonEmails: selectedVendorUsers.map((user) => user.email).join(', '),
    }
  })

  const columnDef = useMemo(
    () => [
      columnHelper.display({
        id: 'select',
        size: 100,
        header: ({ table }) => (
          <IndeterminateCheckbox
            {...{
              checked: table.getIsAllRowsSelected(),
              indeterminate: table.getIsSomeRowsSelected(),
              onChange: table.getToggleAllRowsSelectedHandler(),
            }}
          />
        ),
        cell: ({ row }) => (
          <Box px={1}>
            <IndeterminateCheckbox
              {...{
                checked: row.getIsSelected(),
                disabled: !row.getCanSelect(),
                indeterminate: row.getIsSomeSelected(),
                onChange: row.getToggleSelectedHandler(),
              }}
            />
          </Box>
        ),
      }),
      columnHelper.accessor('vendorName', {
        header: <>Vendor</>,
      }),
      columnHelper.accessor('contactPersonNames', {
        header: <>Contact Person</>,
      }),
      columnHelper.accessor('contactPersonEmails', {
        header: <>Emails</>,
        size: 300,
      }),
    ],
    []
  )

  return (
    <EditableTable
      tableWidth="100%"
      columnDef={columnDef}
      data={formattedVendorDetails}
      disabled={true}
      canSelect
      rowSelection={selectedVendors}
      setRowSelection={setSelectedVendors}
    />
  )
}

export default RFQModalVendorTable
